import { Timeline } from "./timeline.js";

export const TIMELINE = Timeline.create();
